module.exports = __webpack_public_path__ + "img/PRICE.1f29efde.png";